module.exports = "<div class=\"row wrapper border-bottom white-bg page-heading\">\r\n    <div class=\"col-lg-10\">\r\n        <h2>{{title}}</h2>\r\n    </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/common/headerWithRoute/headerWithRoute.component.html
// module id = ./src/app/components/common/headerWithRoute/headerWithRoute.component.html
// module chunks = main